export default "__VITE_ASSET__zGkh8yyu__"